import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AboutYouForm, AboutYouHealthForm } from '@models/SIO/AboutYou.model';
export interface LoadingState {
  income: AboutYouForm | null,
  health: AboutYouHealthForm | null,
  typeUW: string; // SIOB | SIOA1 | SIOA3;
  isCompleted: boolean;
}

const initialState: LoadingState = {
  income: null,
  health: null,
  typeUW: 'SIOB',
  isCompleted: false
}

const step3Slice = createSlice({
  name: 'SIO-Step3',
  initialState,
  reducers: {
    updateTypeUW: (state, action: PayloadAction<string> ) => {
      state.typeUW = action.payload;
    },
    updateIncome: (state, action: PayloadAction<AboutYouForm> ) => {
      state.income = action.payload;
    },
    updateHealth: (state, action: PayloadAction<AboutYouHealthForm> ) => {
      state.health = action.payload;
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
  },
  extraReducers: {}
})

export const { 
  updateHealth,
  updateIncome,
  updateTypeUW,
  completeStep
} = step3Slice.actions;

export default step3Slice.reducer;